// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "1dd8629a6c02085494ac3fc47f66b56941403fdb/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};